import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import LabelInput from '../../../form/component/LabelInput'
import Select from '../../../form/component/Select'
import {getCannotBeTreatedReasonsList} from './CannotBeTreatedReasonWidget'
import currentUserHasAccess from '../../../../util/widget-helper'
import { PRE_TREATMENT_REASON_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'
import {
    CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT,
    MEDICAL_CHECK_WITH_PRETREATMENT,
    MEDICAL_ASSESSMENT,
    CONFIRM_MEDICAL_ASSESSMENT
} from '../../../process/ui-definition/sales-order/in-shop-scan/task-name'

const PRE_TREATMENT_REASON_LIST_WITHOUT_PRETREATMENT = [
    { id: 'caries', value: 'Caries' },
    { id: 'defective_filling', value: 'defective filling' },
    { id: 'gingivitis_prophylaxis', value: 'massive dental calculus' },
    { id: 'parodontosis', value: 'Periodontitis' },
    { id: 'tmj', value: 'TMJ disorder (CMD)' },
]

const PRE_TREATMENT_REASON_LIST_WITH_PRETREATMENT = [
    { id: 'caries', value: 'Caries' },
    { id: 'defective_filling', value: 'defective filling' },
    { id: 'gingivitis_prophylaxis', value: 'massive dental calculus' },
]

const getPretreatmentReasonsList = (taskName) => {
    const taskList = [
        CONFIRM_MEDICAL_CHECK_WITH_PRETREATMENT,
        MEDICAL_CHECK_WITH_PRETREATMENT,
        MEDICAL_ASSESSMENT,
        CONFIRM_MEDICAL_ASSESSMENT
    ]
    const found = taskList.includes(taskName)

    return found ? PRE_TREATMENT_REASON_LIST_WITH_PRETREATMENT : PRE_TREATMENT_REASON_LIST_WITHOUT_PRETREATMENT
}

const customSelectStyle = {
    border: '1px solid rgb(52, 152, 219)',
    height: '50px',
}
const PreTreatmentReasonWidget = ({
    readOnly,
    context,
    changeProcessContext,
    saveProcessContext,
    taskName,
}) => {
    if (!currentUserHasAccess(PRE_TREATMENT_REASON_WIDGET_CONTAINER)) {
        return null;
    }

    return (
        <ContentBox title="Pre Treatment / Cannot be treated reason">
            <Row top="M">
                <Column size={6}>
                    <LabelInput label="Pre Treatment reason">
                        <Select
                            style={customSelectStyle}
                            name="preTreatmentReason"
                            object={context}
                            valueList={getPretreatmentReasonsList(taskName)}
                            addEmpty={true}
                            readOnly={readOnly}
                            onChange={(name, value) => {
                                changeProcessContext(name, value)
                                saveProcessContext()
                            }}
                        />
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="Cannot be treated reason">
                        <Select
                            style={customSelectStyle}
                            name="cannotBeTreatedReason"
                            object={context}
                            valueList={getCannotBeTreatedReasonsList(taskName)}
                            addEmpty={true}
                            readOnly={readOnly}
                            onChange={(name, value) => {
                                changeProcessContext(name, value)
                                saveProcessContext()
                            }}
                        />
                    </LabelInput>
                </Column>
            </Row>
        </ContentBox>
    )
}

PreTreatmentReasonWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    context: PropTypes.object.isRequired,
    changeProcessContext: PropTypes.func.isRequired,
    saveProcessContext: PropTypes.func.isRequired,
    taskName: PropTypes.string.isRequired,
    validationMessageList: PropTypes.array.isRequired,
}

export default PreTreatmentReasonWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/PreTreatmentReasonWidget.js